export const setPointerPosition = (currentTab, pointer) => {
	pointer.style.cssText = `top:${currentTab.offsetTop}px;left:${currentTab.offsetLeft}px;width:${currentTab.offsetWidth}px;height:${currentTab.offsetHeight}px;`;
};
